module.exports = new __parcel__URL__("inception.70314cc4.jpg").toString();